import { useMemo } from 'react';
import { TimeSignal, TimeSignalSource } from 'graphql/types';
import config from 'modules/../config';

export const isManualNote = (note: TimeSignal): boolean => {
  return note.sources.some(
    (source: TimeSignalSource) => source.id === config.clientId
  );
};

const sortByPrecedence = (note1: TimeSignal, note2: TimeSignal) => {
  if (!note1.excluded && note2.excluded) {
    return -1;
  }

  if (note1.excluded && !note2.excluded) {
    return 1;
  }

  if (isManualNote(note1) && !isManualNote(note2)) {
    return -1;
  }

  if (!isManualNote(note1) && isManualNote(note2)) {
    return 1;
  }

  if (note1?.duration && !note2.duration) {
    return -1;
  }

  if (!note1?.duration && note2.duration) {
    return 1;
  }

  if (note1.duration && note2.duration && note1?.duration > note2?.duration) {
    return -1;
  }

  if (note1.duration && note2.duration && note1?.duration < note2?.duration) {
    return 1;
  }

  if (note1.startTime < note2.startTime) {
    return -1;
  }

  if (note1.startTime > note2.startTime) {
    return 1;
  }

  return -1;
};

export const useGroupPrimaryNote = (notes: TimeSignal[]): TimeSignal => {
  return useMemo(() => {
    const sortedNotes = [...notes].sort(sortByPrecedence);

    return sortedNotes?.[0];
  }, [notes]);
};
